import { Typography } from '@material-ui/core'

export const Text = (props) => {
    return (
        <Typography {...props}>

        </Typography>
    )
}
